/* This file is autogenerated, see readme.md for instructions */
import MobilePhonePortraitSvgIcon from '@bloomreach/banana-theme/icons/mobile-phone-portrait.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const MobilePhonePortraitIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <MobilePhonePortraitSvgIcon />
    </Icon>
  );
});

MobilePhonePortraitIcon.displayName = 'MobilePhonePortraitIcon';

export default MobilePhonePortraitIcon;
